export const icons = [
  "leftsnap",
  "rightsnap",
  "topsnap",
  "bottomsnap",
  "selecticon",
  "line",
  "cancelfullscreen",
  "fullscreen",
  "template",
  "404",
  "apiyun",
  "barGraph",
  "bug",
  "cc",
  "chart",
  "clipboard",
  "component",
  "dashboard",
  "deblocking",
  "design",
  "documentation",
  "drag",
  "edit",
  "email",
  "examination",
  "example",
  "excel",
  "eye",
  "folder",
  "form",
  "forum",
  "gou",
  "guide",
  "help",
  "icon",
  "international",
  "iPad",
  "jinru",
  "language",
  "list",
  "lock",
  "lockOut",
  "logic",
  "message",
  "money",
  "nested",
  "password",
  "PC",
  "people",
  "peoples",
  "phone",
  "qq",
  "return",
  "run",
  "shoppingCard",
  "star",
  "tab",
  "table",
  "theme",
  "tranfer",
  "tree",
  "user",
  "wechat",
  "zip",
  "ctrlcom",
  "property",
  "hide",
  "assembly",
  "layout",
  "imglayout",
  "share",
  "random",
];
